import React from 'react';
import { useIntl } from 'react-intl-next';
import TextRenderType from '../text';
import { booleanTypeMessages } from './messages';
export var BOOLEAN_TYPE_TEST_ID = 'link-datasource-render-type--boolean';
var BooleanRenderType = function BooleanRenderType(_ref) {
  var value = _ref.value,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? BOOLEAN_TYPE_TEST_ID : _ref$testId;
  var intl = useIntl();
  if (typeof value !== 'boolean') {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  var TRUTHY_TEXT = intl.formatMessage(booleanTypeMessages.booleanTruthyValue);
  var FALSY_TEXT = intl.formatMessage(booleanTypeMessages.booleanFalsyValue);
  return /*#__PURE__*/React.createElement(TextRenderType, {
    text: value ? TRUTHY_TEXT : FALSY_TEXT,
    testId: testId
  });
};
export default BooleanRenderType;